import React from 'react';
import { IconNotificationError } from '@snsw/react-component-library';
import classes from './FieldError.module.scss';

const FieldError = ({ message }) => (
  <div className={classes.errorContainer}>
    <IconNotificationError />
    <div>{message}</div>
  </div>
);

export default FieldError;
